import React, { useEffect, useState } from 'react'
import { IoIosArrowDown } from "react-icons/io";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import LanguageDropdown from '../../../components/languageDropdown/LanguageDropdown';
import MenuHelper from '../../../helpers/MenuHelper';
import { NavLink, useNavigate } from 'react-router-dom';
import Language from '../../../components/languageDropdown/Language';
import ThemeMode from '../../../components/ThemeMode/ThemeMode';
import { BiSun } from "react-icons/bi";
import { MdInfoOutline } from "react-icons/md";
import { FiExternalLink } from "react-icons/fi";
import Popup from '../../../components/popup/Popup';
import { makeAjax, respStatus, url } from '../../../helpers/global_helper';
import ErrorBoundary from '../../../helpers/ExceptionHandler/componentException';
import { CiMobile3 } from "react-icons/ci";

const initSetting = {
    floating_link_pf: null,
    class: null,
    default_class: null,
};

const SideBarMenuGrid = (props) => {
    const frontendLang = Language;
    const selectedLang = localStorage.getItem("I18N_LANGUAGE") || 'id';
    const [dropdowntransOpen, setDropdowntransOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [gridCommonMenu, setgridCommonMenu] = useState([]);
    const [gridInfoMenu, setGridInfoMenu] = useState([]);
    const [listMenu, setListMenu] = useState([]);
    const [dropdowninfoOpen, setDropinfodownOpen] = useState(false);
    const [alternativeSite, setAlternativeSite] = useState([]);
    const [dropdownAlterLinkOpen, setdropdownAlterLinkOpen] = useState(false);
    const [copiedIndex, setCopiedIndex] = useState(null);
    const [isPopup, setIsPopup] = useState(false);

    useEffect(() => {
        if (props?.menuList && Object?.keys(props?.menuList)?.length) {
            const gridCommonMenuItems = [];
            const listMenuItems = [];
            const gridInfoItems = [];
            const excludedMenus = ['categories', 'mobile', 'register', 'live-chat', 'language', 'promotion'];
            const infoTabMenu = ["promotion", 'blogs', "about-us", "terms-and-conditions", 'help']

            Object.values(props?.menuList).forEach((menu) => {
                if (menu.status && menu.code === 'home' || menu.code === 'all-games' || menu.code === 'referral' || menu.code === 'my-referral' || menu.parent_menu_code === 'categories') {
                    gridCommonMenuItems.push(menu);
                } else if (menu.status && infoTabMenu.includes(menu.code)) {
                    gridInfoItems.push(menu);
                }
                else if (menu.status && !excludedMenus.includes(menu.code)) {
                    listMenuItems.push(menu);
                }
            });

            setgridCommonMenu(gridCommonMenuItems);

            //only remove hkb-transactions from dropdown
            const removeHkbTransactions = listMenuItems.filter((item) => item.code !== "hkb-transactions")
            setListMenu(removeHkbTransactions);
            // setListMenu(listMenuItems);
            setGridInfoMenu(gridInfoItems);
        }
    }, [props?.menuList]);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const toggletarnsDropdown = () => {
        setDropdowntransOpen(!dropdowntransOpen);
    }

    const toggleInfoDropdown = () => {
        setDropinfodownOpen(!dropdowninfoOpen);
    }

    const getAlternativeSite = () => {
        setAlternativeSite(JSON.parse(localStorage.getItem('alternative_site')));
    };

    useEffect(() => {
        getAlternativeSite();
    }, []);


    const toggleAlterLinkDropdown = () => {
        setdropdownAlterLinkOpen((prev) => !prev);
    };

    const handleCopy = (index, domain) => {
        const link = `http${domain.is_secured ? 's' : ''}://${domain.domain}`;
        navigator.clipboard.writeText(link)
            .then(() => {
                setCopiedIndex(index);
            })
            .catch((error) => console.error('Failed to copy: ', error));
    };

    const handlePopup = () => {
        setIsPopup(!isPopup);
    };

    return (
        <>
            <div className='sidebar-menu-grid'>
                <ul className='sidebarGrid'>
                    {gridCommonMenu.map((item, index) => {
                        const customLink = item.code === 'home' ? '' : item.code === 'my-referral' ? 'referral' : item.code;
                        return (
                            <React.Fragment key={index}>
                                {item.status &&
                                    <>
                                        <li>
                                            <NavLink to={customLink} onClick={() => props.handleClose()} className="menu-grid-a border-sidebar_menu text-sidebar_menu">
                                                <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={item} className={"sidebar-img"} newLine={true} />
                                            </NavLink>
                                        </li>
                                    </>
                                }
                            </React.Fragment>
                        );
                    })}
                </ul>

                {props?.loggedIn &&
                    <>
                        <a className={`sidebarTransDropdown menu-grid-a border-sidebar_menu text-sidebar_menu ${dropdowntransOpen ? 'sidebarTransDropdown-open' : ''}`} onClick={toggletarnsDropdown}>
                            {listMenu.some((item) => item.code === 'transactions') && (
                                <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={listMenu.find((item) => item.code === 'transactions')} className="sidebar-img" />
                            )}
                            <IoIosArrowDown className="down-arrow" />
                        </a>
                        {dropdowntransOpen && <ul className='sidebarTransGrid'>
                            {listMenu.map((item, index) => (
                                <>
                                    {item?.parent_menu_code == "transactions" && item?.location === 'sub_menu' &&
                                        <>
                                            <li key={index}>
                                                <NavLink className="menu-grid-a border-sidebar_menu text-sidebar_menu" to={item.code} onClick={(e) => {
                                                    e.preventDefault();
                                                    props.handleClose(item.code)
                                                }}>
                                                    <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={item} className={"sidebar-img"} newLine={true} />
                                                </NavLink>
                                            </li>

                                        </>

                                    }
                                </>
                            ))}
                        </ul>}
                    </>
                }

                {/* <ul className='sidebarList'>
                {listMenu.map((item, index) => {
                    if (item.parent_menu_code !== "transactions" && item.location === 'menu' && item.code !== 'transactions') {

                        return (
                            <li key={index}>
                                <NavLink to={item.code} onClick={() => props.handleClose()}>
                                    <MenuHelper t={props.t} ftpPath={props.playerMenu?.ftp_path} data={item} className="sidebar-img" />
                                </NavLink>
                            </li>
                        );
                    }
                    return null;
                })}
            </ul> */}

                <a className={`sidebarInfoDropdown  menu-grid-a border-sidebar_menu text-sidebar_menu ${dropdowninfoOpen ? 'sidebarInfoDropdown-open' : ''}`} onClick={toggleInfoDropdown}>
                    <div className='d-flex'><span><MdInfoOutline /></span><span>{props.t('information')}</span></div>
                    <IoIosArrowDown className="down-arrowinfo" />
                </a>
                {dropdowninfoOpen && <ul className='sidebarGrid'>
                    {gridInfoMenu.map((item, index) => {
                        return (
                            <li key={index}>
                                <NavLink to={item.code} onClick={() => props.handleClose()} className="menu-grid-a border-sidebar_menu text-sidebar_menu">
                                    <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={item} className={"sidebar-img"} newLine={true} />
                                </NavLink>
                            </li>
                        );
                    })}
                </ul>}

                <>
                    <ul className='sidebarList'>
                        <li>
                            <a className='menu-grid-a border-sidebar_menu text-sidebar_menu'>
                                <BiSun />
                                <span>{props.t('light_mode')}</span>
                                <ErrorBoundary><ThemeMode /></ErrorBoundary>
                            </a>
                        </li>
                    </ul>

                    <a className={`language-grid menu-grid-a border-sidebar_menu text-sidebar_menu  ${dropdownOpen ? 'language-grid-open' : ''}`} onClick={toggleDropdown}>
                        <div className='d-flex align-items-center'>
                            {selectedLang ? (
                                <img
                                    className='lang-flag'
                                    loading="lazy"
                                    src={frontendLang[selectedLang].flag}
                                    alt={selectedLang}
                                />
                            ) : null}

                            <span>{props.t('language')} : {frontendLang[selectedLang].label}</span></div>

                        <IoIosArrowDown className="down-arrow" />
                    </a>
                    {dropdownOpen && <ErrorBoundary><LanguageDropdown view="mobile" /></ErrorBoundary>}


                    <a
                        className={`sidebarAlterLinkDropdown menu-grid-a border-sidebar_menu text-sidebar_menu ${dropdownAlterLinkOpen ? 'sidebarAlterLinkDropdown-open' : ''}`}
                        onClick={toggleAlterLinkDropdown}
                    >
                        <div className="d-flex">
                            <span><FiExternalLink /></span>
                            <span>{props.t('alternate_links')}</span>
                        </div>
                        <IoIosArrowDown className="down-arrowinfo" />
                    </a>

                    <ul className='sidebarList'>
                        <li >
                            <a className='menu-grid-a border-sidebar_menu text-sidebar_menu' onClick={handlePopup}>
                                <CiMobile3 />
                                <span>{props.t('game_apk')}</span>
                            </a>
                        </li>
                    </ul>
                    {dropdownAlterLinkOpen && (
                        <ul className="link_ol">
                            {alternativeSite.map(
                                (v, i) =>
                                    v?.is_user_app_visibility && (
                                        <li key={i} className="alter-link">
                                            <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={`http${v.is_secured ? 's' : ''}://${v.domain}`}
                                            >
                                                {v.domain}
                                            </a>
                                            <button
                                                className="alter-link-btn"
                                                onClick={() => handleCopy(i, v)}
                                            >
                                                {copiedIndex === i ? props.t('copied') : props.t('copy')}
                                            </button>
                                        </li>
                                    )
                            )}
                        </ul>
                    )}

                </>
            </div >

            {isPopup && (
                <Popup
                    handlePoup={handlePopup}
                    gameApk
                />
            )}

        </>
    )
}
SideBarMenuGrid.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};
export default withTranslation()(SideBarMenuGrid);


